module.exports = __webpack_public_path__ + "img/zk-icon-sales-order.8d1b95f4.svg";